import React from 'react';
import { useQuery, gql } from '@apollo/client';

import withApollo from 'data/with-apollo';
import PageLayout from 'components/page-layout';
import TornSection from 'components/torn-section';
import PageContainer from 'components/page-container';
import PageTitle from 'components/page-title';
import HTML from 'components/html';

const GET_PAGE = gql`
  query {
    bHRPage(id: "about", idType: SLUG) {
      title
      content(format: RENDERED)
    }
  }
`;

const AboutPage = () => {
  const { data } = useQuery(GET_PAGE);
  const page = data?.bHRPage;

  if (!page) return null;
  return (
    <PageLayout>
      <TornSection as="main" className="my-12 lg:my-24">
        <PageContainer>
          <div className="max-w-4xl">
            <PageTitle>{page.title}</PageTitle>
            <HTML className="text-gray-base text-lg leading-loose text-shadow rich-text">
              {page.content}
            </HTML>
          </div>
        </PageContainer>
      </TornSection>
    </PageLayout>
  );
};

export default withApollo(AboutPage);
